<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        style="fill: currentColor"
    >
        <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.!-->
        <path
            d="M272 256h91.4c43.2 0 82-32.2 84.5-75.3a79.8 79.8 0 0 0 -25.3-63.1 79.8 79.8 0 0 0 9.1-44.9C427.9 30.6 389.3 0 347 0h-75a16 16 0 0 0 -16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.1 22.3A32 32 0 0 0 124.6 0H99.4a32 32 0 0 0 -30.5 22.3L.6 235.7A16 16 0 0 0 16 256h24.9a16 16 0 0 0 15.4-11.7L68.3 208h87.4l11.9 36.3A16 16 0 0 0 183.1 256H208a16 16 0 0 0 15.4-20.3zM89.4 144L112 75.3l22.6 68.7zm482 132.5l-45.2-45.3a15.9 15.9 0 0 0 -22.6 0l-151.5 151.5-55.4-55.5a15.9 15.9 0 0 0 -22.6 0l-45.3 45.3a16 16 0 0 0 0 22.6l112 112.2a15.9 15.9 0 0 0 22.6 0l208-208.2a16 16 0 0 0 0-22.6z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "fa-spell-check",
});
</script>
